import { render } from "./RegisterSuccess.vue?vue&type=template&id=837e591c&ts=true"
import script from "./RegisterSuccess.vue?vue&type=script&lang=ts"
export * from "./RegisterSuccess.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/sylvainleris/Documents/workspace/ADETEC/AdConnect/fr.adetec.adconnect.www/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__